import http from "./http.js";

async function getPayer(id) {
  try {
    const response = await http.get(`payers/${id}`);
    return {
      title: response.data.title,
      code: response.data.code,
      IsPrivatePerson: response.data.isPrivatePerson,
      client: response.data.client
        ? { id: response.data.client.id, title: response.data.client.title }
        : null,
    };
  } catch (err) {
    throw err;
  }
}

async function updatePayer(id, payer) {
  try {
    const response = await http.put(`payers/${id}`, payer);
    return response;
  } catch (err) {
    throw err;
  }
}

async function createPayer(payer) {
  try {
    const response = await http.post("payers", payer);
    return response;
  } catch (err) {
    throw err;
  }
}

async function getPayers(page = 1, rowsPerPage = 9, search = "", filter = "") {
  try {
    const response = await http.get(
      `payers?page=${page}&pageSize=${rowsPerPage}&searchTerm=${search}${filter}`
    );
    return response.data;
  } catch (err) {
    throw err;
  }
}

async function selectPayer(page = 1, rowsPerPage = 9, search = "") {
  try {
    const response = await http.get(
      "payers/references", {
        params: {
          page,
          pageSize: rowsPerPage,
          searchTerm: search,
        },
      }
    );
    return response.data;
  } catch (err) {
    throw err;
  }
}

export { getPayer, updatePayer, createPayer, selectPayer, getPayers };
